import React from 'react'
import {
  MicrosoftParamsTabStyled,
  MicrosoftTabText,
} from 'Features/CheqParamsModal/Tabs/Microsoft/MicrosoftParamsTab.styled'
import { CodeWrapper } from 'Features/CheqParamsModal/CheqParamsModal.styled'
import { Trans, useTranslation } from 'react-i18next'
import { OutsideLink, CopyTextButton } from '@clickcease/cc-client-components-lib'

export const MicrosoftParamsTab = () => {
  const { t } = useTranslation('domainManagement')
  const learnMoreUrl = 'https://help.ads.microsoft.com/#apex/ads/en/51091/2-500'
  const code =
    'cq_src=bing_ads&cq_cmp={Campaign}&cq_con={AdGroup}&cq_term={keyword}&cq_med={CriterionId}&cq_net={Network}&cq_plt=bp'
  return (
    <MicrosoftParamsTabStyled>
      <MicrosoftTabText>
        <Trans ns="domainManagement" i18nKey="tracking_params_modal.microsoft_tab.text">
          To gain more insights, add the following parameters.
          <OutsideLink target={'_blank'} href={learnMoreUrl}>
            Learn more
          </OutsideLink>
        </Trans>
      </MicrosoftTabText>
      <CodeWrapper>{code}</CodeWrapper>
      <CopyTextButton buttonText={t('tracking_params_modal.copy')} value={code} />
    </MicrosoftParamsTabStyled>
  )
}
